export default {
  common: {
    home: 'Bosh sahifa',
    loading: 'Yuklanmoqda...',
    allNews: 'Barcha yangiliklar',
    goToSite: 'Saytga oʻtish',
    language: 'Til',
    menu: 'Menyu',
    notFound: 'Maqola topilmadi.',
    backToList: 'Roʻyxatga qaytish',
    orgName: 'Oʻzbekiston Respublikasi Taʼlimni rivojlantirish respublika ilmiy-metodik markazi',
    testMode: 'Sayt test rejimida ishlamoqda',
    newsNotFound: 'Yangilik topilmadi.',
    gerbAlt: 'Oʻzbekiston Respublikasi gerbi',
    views: 'Koʻrishlar',
    soon: 'Tez orada'
  },

  nav: {
    markaz: 'Markaz',
    faoliyat: 'Faoliyat',
    hujjatlar: 'Hujjatlar',
    axborot: 'Axborot xizmati',
    pisa: 'PISA',
    boglanish: 'Bogʻlanish',

    markazHaqida: 'Markaz haqida',
    rahbariyat: 'Rahbariyat',
    boshqarmaBoshliqlari: 'Boshqarma boshliqlari',
    tuzilma: 'Tuzilma',

    oquvMetodik: 'Taʼlimni oʻquv-meʼyoriy va metodik muvofiqlashtirish',
    baholashMonitoring: 'Taʼlim sifatini baholash va monitoring qilish',
    raqamliSavodxonlik: 'Raqamli savodxonlik va innovatsion texnologiyalarni joriy etish',
    talimNormativlari: 'Taʼlimni pedagogik-psixologik qoʻllab-quvvatlash',
    hisobotlar: 'Hisobotlar',

    prezidentFarmonlari: 'Prezident farmonlari, farmoyishlari va qarorlari',
    talimgaOidQonunlar: 'Taʼlimga oid qonunlar',
    vazirlarMahkamasi: 'Vazirlar Mahkamasi qarorlari',
    markazFaoliyati: 'Markaz faoliyatiga doir hujjatlar',
    talimgaDoirHujjatlar: 'Taʼlimga doir hujjatlar',

    yoshOlimlar: 'Yosh olimlar va tadqiqotchilar maktabi',
    savolJavob: 'Savol va javob',
    ochiqMalumotlar: 'Ochiq maʼlumotlar',
    yangiliklar: 'Yangiliklar',
    galereya: 'Galereya',
    ilmiyMaqolalar: 'Ilmiy maqolalar',

    ilmiyMetodik: 'Ilmiy-metodik faoliyat va xalqaro hamkorlik',
    ilmiyMetodikFaoliyat: 'Ilmiy-metodik faoliyat',
    xalqaroHamkorlik: 'Xalqaro hamkorlik',
    ilmiyLoyihalar: 'Ilmiy tadqiqot loyihalari'
  },

  footer: {
    copyright: '© 2026. Materialdan toʻliq yoki qisman foydalanganda, trm.uz manbasi koʻrsatilishi shart.',
    callAria: 'Telefon qilish: {phone}',
    emailAria: 'Email yozish: {email}'
  },

  a11y: {
    title: 'Maxsus imkoniyatlar',
    close: 'Yopish',
    fontSize: 'Shrift oʻlchami:',
    zoom: 'Masshtab:',
    screenReader: 'Ekran suxandoni:',
    toggle: 'Yoqish / Oʻchirish',
    maleVoice: 'Erkak ovozi',
    femaleVoice: 'Ayol ovozi',
    readerHint: 'Yoqilganda, oʻqilishi kerak boʻlgan matn ustiga bosing.',
    googleTranslate: 'Google tarjimon:',
    selectLanguage: 'Tilni tanlang',
    readingMode: 'Oʻqish rejimi',
    reset: 'Boshlangʻich holatga qaytarish',
    modeDefault: 'Oddiy',
    modeInvert: 'Ranglarni teskari',
    modeContrast: 'Kontrast',
    modeGray: 'Kulrang'
  },

  pager: {
    label: 'Sahifalar',
    first: 'Birinchi sahifa',
    prev: 'Oldingi sahifa',
    next: 'Keyingi sahifa',
    last: 'Oxirgi sahifa'
  },

  lightbox: {
    prev: 'Oldingi',
    next: 'Keyingi'
  },

  home: {
    heroTitle: 'Taʼlim sifatini takomillashtirish yoʻlida',
    heroSubtitle: 'Taʼlim mazmuni, metodikasi va sifat monitoringini rivojlantirish boʻyicha faoliyat yurituvchi markaz',

    featureOquvMetodik: 'Taʼlimni oʻquv-meʼyoriy va metodik muvofiqlashtirish',
    featureBaholash: 'Taʼlim sifatini baholash va monitoring qilish',
    featureNormativlar: 'Taʼlimni pedagogik-psixologik qoʻllab-quvvatlash',
    featureRaqamli: 'Raqamli savodxonlik va innovatsion texnologiyalarni joriy etish',

    newsTitle: 'Yangiliklar va eʼlonlar',

    prezidentQuote: 'Taraqqiyotning tamal toshi ham, mamlakatni qudratli, millatni buyuk qiladigan kuch ham ilm-fan, taʼlim va tarbiyadir.',
    prezidentName: 'Shavkat Mirziyoyev',
    prezidentRole: 'Oʻzbekiston Respublikasi Prezidenti',

    statMaktabgacha: 'Maktabgacha taʼlim tashkilotlari',
    statUmumiy: 'Umumiy oʻrta taʼlim tashkilotlari',
    statKasbiy: 'Oʻrta maxsus va kasbiy taʼlim tashkilotlari',
    statOliy: 'Oliy taʼlim tashkilotlari',

    mediaTitle: 'Media',
    mediaPhotos: 'Fotolavhalar',
    mediaVideos: 'Videolavhalar',
    mediaNoVideos: 'Hozircha videolavhalar mavjud emas.',
    mediaNoPhotos: 'Hozircha fotolavhalar mavjud emas.',
    mediaPlay: 'Videoni ijro etish',

    portalTitle: 'Yagona raqamli taʼlim resurslari va xizmatlari portali',
    portalSubtitle: 'Taʼlimda metodik yordam koʻrsatish ekotizimi',

    linksTitle: 'Foydali havolalar',
    linkIma: 'Ixtisoslashtirilgan taʼlim muassasalari agentligi',
    linkGov: 'Oʻzbekiston Respublikasi Hukumat portali',
    linkUzedu: 'Maktabgacha va maktab taʼlimi vazirligi',
    linkOliy: 'Oliy taʼlim, fan va innovatsiyalar vazirligi'
  },

  pages: {
    comingSoon: {
      title: 'Tez orada',
      text: 'Bu boʻlim ustida ish olib borilmoqda. Maʼlumotlar yaqin orada joylashtiriladi.'
    },

    hisobotlar: {
      intro: 'Markaz faoliyati toʻgʻrisidagi choraklik, yarim yillik va yillik hisobotlar.',
      typeFilter: 'Hisobot turi',
      yearFilter: 'Yil',
      all: 'Barchasi',
      quarterly: 'Choraklik',
      halfYear: 'Yarim yillik',
      annual: 'Yillik',
      allYears: 'Barcha yillar',
      periods: { q1: 'I chorak', q2: 'II chorak', q3: 'III chorak', q4: 'IV chorak', h1: 'I yarim yillik', h2: 'II yarim yillik', year: 'Yillik' },
      yearLabel: '{year}-yil',
      empty: 'Hisobotlar hali eʼlon qilinmagan.',
      noMatch: 'Tanlangan davr boʻyicha hisobot topilmadi.',
      resetFilters: 'Filtrlarni tozalash',
      download: 'Hisobotni yuklab olish',
      attachment: 'Ilova fayl',
      notFound: 'Hisobot topilmadi.',
      others: 'Boshqa hisobotlar',
      kpiTotal: 'Jami hisobot',
      kpiPublished: 'Eʼlon qilingan',
      kpiPending: 'Kutilmoqda',
      progress: '{year} yil choraklari',
      legendDone: 'Eʼlon qilindi',
      legendNow: 'Joriy chorak',
      legendWait: 'Kutilmoqda',
      search: 'Hisobotlarni izlash',
      preparing: 'Tayyorlanmoqda',
      downloadShort: 'Yuklash',
      more: 'Batafsil',
      count: '{n} ta hisobot',
      range: '{from} — {to} {year}',
      months: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr']
    },

    ochiqMalumotlar: {
      openFile: 'faylni ochish'
    },

    oquvMetodik: {
      figAlt1: 'Oʻquv-metodik komplekslar — amalga oshirilgan ishlar (1)',
      figAlt2: 'Oʻquv-metodik komplekslar — amalga oshirilgan ishlar (2)',
      blocks: [
        { type: 'lead', text: 'Taʼlimni oʻquv-meʼyoriy va metodik muvofiqlashtirish boshqarmasi' },
        { type: 'label', text: 'Boshqarmada quyidagi boʻlimlar mavjud:' },
        { type: 'list', items: [
          'Taʼlim dasturlari va oʻquv-metodik komplekslarni joriy etish boʻlimi',
          'Ekspert-tahlil xizmatlarini amalga oshirish boʻlimi'
        ] },
        { type: 'section', text: 'Boshqarmaning vazifa va funksiyalari' },
        { type: 'list', items: [
          'taʼlim sohasida oʻquv-meʼyoriy hujjatlar, oʻquv reja va dasturlari, oʻquv-metodik komplekslarni ishlab chiqish, tahlil qilish va joriy etish jarayonlarini muvofiqlashtirish, shuningdek, ularning amaliyotga tatbiq etilishini taʼminlash;',
          'maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tashkilotlari, shuningdek, qisqa muddatli, shu jumladan xususiy oʻquv kurslarning taʼlim standartlari, oʻquv rejalari va dasturlariga qoʻyiladigan talablarni ishlab chiqish;',
          'maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tashkilotlarida oʻqitish metodikasini takomillashtirish, zamonaviy talablar va ilgʻor xorijiy tajriba asosida yangi oʻquv-metodik komplekslarni nashr etish va amaliyotga joriy etilishini muvofiqlashtirish;',
          'oʻquv-metodik komplekslarni tajriba-sinovdan oʻtkazish, ilmiy-ekspertizadan oʻtkazish, olingan natijalarni tahlil qilish va ularni takomillashtirish boʻyicha tizimli ilmiy-metodik ishlarni tashkil etish;',
          'taʼlim sohasida ekspert-tahlil faoliyatini rivojlantirish, oʻquv dasturlari, metodik qoʻllanmalar, darsliklar va boshqa oʻquv-metodik mahsulotlar boʻyicha ekspert xulosalarini tayyorlash hamda ilmiy asoslangan metodik tavsiyalar ishlab chiqishni amalga oshirish;',
          'Markaz huzurida tashkil etilgan fan yoʻnalishlari boʻyicha Ilmiy-metodik kengashlar faoliyatini muvofiqlashtirish;',
          'taʼlim sohasini rivojlantirishga qaratilgan tahliliy va amaliy tadqiqotlar oʻtkazish, taʼlim jarayonida jahon ilm-fani va texnologiyalari yutuqlaridan keng foydalanish boʻyicha ilmiy ishlanmalar va tavsiyalar tayyorlash;',
          'xalqaro tashkilotlar, ilmiy markazlar va ilgʻor xorijiy nashriyotlar bilan hamkorlikda taʼlim mazmunini takomillashtirishga doir ilmiy-amaliy tashabbuslarni amalga oshirish, ilgʻor xorijiy tajribalarni oʻrganib, mahalliy amaliyotga moslashtirishni taʼminlash.'
        ] }
      ]
    },

    markazHaqida: {
      title: 'TAʼLIMNI RIVOJLANTIRISH RESPUBLIKA ILMIY-METODIK MARKAZI',
      tasksTitle: 'MARKAZNING ASOSIY VAZIFALARI:',
      tasks: [
        'taʼlim jarayoniga innovatsion pedagogik texnologiyalarni, oʻqitishning samarali shakl va usullarini, taʼlim sifatini baholash va monitoring qilishning zamonaviy tizimlarini joriy qilish;',
        'maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tashkilotlari, shuningdek, qisqa muddatli, shu jumladan xususiy oʻquv kurslar (keyingi oʻrinlarda — oʻquv kurslari)ning taʼlim standartlari, oʻquv rejalari va dasturlariga qoʻyiladigan talablarni ishlab chiqish va tasdiqlash;',
        'taʼlim tashkilotlarida oʻqitish metodikasini takomillashtirish, zamonaviy talablar va ilgʻor xorijiy tajriba asosida yangi darsliklar va oʻquv-metodik majmualarni nashr qilish, tajriba-sinovdan oʻtkazish va ekspertiza qilishni tashkillashtirish;',
        'taʼlim tashkilotlarining rahbar va pedagogik kadrlarini tayyorlash, qayta tayyorlash va ularning malakasini oshirishning ilgʻor shakllarini joriy qilish, oʻqituvchilarning kasbiy mahoratini uzluksiz oshirib borish uchun shart-sharoit yaratish;',
        'taʼlim tashkilotlaridagi oʻquv-tarbiya jarayonlari va kadrlarni tayyorlash sifatini monitoring qilishda, taʼlim oluvchilarning bilimi taʼlim standartlari va talablariga muvofiqligini tahlil qilishda ishtirok etish, Oʻzbekiston Respublikasida taʼlim sifati sohasida xalqaro dasturlar va tadqiqotlar oʻtkazilishini tashkillashtirish;',
        'taʼlim sohasini rivojlantirishga qaratilgan tahliliy va amaliy tadqiqotlar oʻtkazish, taʼlim jarayonida jahon ilm-fani va texnologiyalari yutuqlaridan keng foydalanish boʻyicha ilmiy ishlanmalar va tavsiyalar tayyorlash;',
        'taʼlim sohasidagi ilgʻor amaliyotni oʻrganish va tizimli tahlil qilish hamda uni respublikada joriy etish boʻyicha kompleks chora-tadbirlarni qabul qilish, yetakchi xorijiy ilmiy-tadqiqot tashkilotlari bilan aloqalarni rivojlantirish.',
        'respublika markazi tomonidan ishlab chiqilgan va tasdiqlangan taʼlim standartlari, oʻquv rejalari va dasturlariga qoʻyiladigan talablar maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tashkilotlari, shuningdek, oʻquv kurslari uchun majburiy hisoblanadi;'
      ]
    },

    tuzilma: {
      heading: 'Taʼlimni rivojlantirish respublika ilmiy-metodik markazi tuzilmasi',
      annex: 'Oʻzbekiston Respublikasi Prezidentining 2023-yil 20-apreldagi PQ-128-son qaroriga ILOVA',
      staff: 'Xodimlarning umumiy soni — 42 nafar, shu jumladan boshqaruv xodimlari — 15 nafar, ilmiy xodimlar — 27 nafar.',
      revision: '(ilovaning matni Oʻzbekiston Respublikasi Prezidentining 2025-yil 29-oktabrdagi PF-197-sonli Farmoni tahririda)',
      director: 'Direktor',
      advisors: 'Maslahatchilar',
      deputy: 'Direktor oʻrinbosari',
      board1: 'Taʼlimni oʻquv-meʼyoriy va metodik muvofiqlashtirish boshqarmasi',
      b1u1: 'Taʼlim dasturlari va oʻquv-metodik komplekslarni joriy etish boʻlimi',
      b1u2: 'Ekspert-tahlil xizmatlarini amalga oshirish boʻlimi',
      board2: 'Taʼlimni pedagogik-psixologik qoʻllab-quvvatlash boshqarmasi',
      b2u1: 'Pedagogik mahorat va inklyuziv taʼlimni rivojlantirish boʻlimi',
      b2u2: 'Psixologik xizmatni rivojlantirish va kasbga yoʻnaltirish boʻlimi',
      board3: 'Taʼlim sifatini baholash va monitoring qilish boshqarmasi',
      b3u1: 'Baholash va ijtimoiy-amaliy tadqiqotlar boʻlimi',
      b3u2: 'Xalqaro dasturlar va reytinglardagi koʻrsatkichlar tahlili boʻlimi',
      board4: 'Raqamli savodxonlik va innovatsion texnologiyalarni joriy etish boshqarmasi',
      b4u1: 'Raqamli pedagogika va mediataʼlimni rivojlantirish boʻlimi',
      b4u2: 'Raqamli texnologiyalar va innovatsiyalarni joriy etish boʻlimi',
      s1: 'Axborot xizmati',
      s2: 'Buxgalteriya hisobi boʻlimi',
      s3: 'Ilmiy-metodik faoliyat va xalqaro hamkorlikni muvofiqlashtirish boʻlimi',
      s4: 'Inson resurslarini rivojlantirish xizmati',
      s5: 'Ijro intizomi va murojaatlar bilan ishlash xizmati',
      s6: 'Yuriskonsult',
      s7: 'AKT boʻyicha bosh mutaxassis'
    },

    contact: {
      title: 'Har qanday savol yoki taklifingiz boʻlsa, bizga yozishingiz mumkin',
      address: 'Toshkent shahri, Navoiy koʻchasi, 30-uy',
      mapTitle: 'Markaz joylashuvi',
      formTitle: 'Xabar yuborish',
      name: 'Ismingiz',
      phone: 'Telefon raqamingiz',
      email: 'Elektron pochta',
      subject: 'Mavzu',
      choose: 'Tanlang',
      message: 'Xabar',
      send: 'Yuborish',
      sending: 'Yuborilmoqda...',
      sent: 'Xabaringiz yuborildi. Tez orada javob beramiz.',
      topicGeneral: 'Umumiy savol',
      topicSuggestion: 'Taklif',
      topicComplaint: 'Shikoyat',
      topicCooperation: 'Hamkorlik',
      errName: 'Ismingizni kiriting.',
      errMessage: 'Xabar matni kamida 5 ta belgidan iborat boʻlsin.',
      errPhone: 'Telefon raqamini toʻliq kiriting (+998 va 9 ta raqam).',
      errSend: 'Xabarni yuborib boʻlmadi. Internetni tekshirib, qayta urinib koʻring.'
    },

    ilmiy: {
      head: 'Taʼlimni rivojlantirish respublika ilmiy-metodik markazi xodimlari tomonidan chop etilgan ilmiy ishlari roʻyxati',
      colNo: '№',
      colName: 'F.I.Sh',
      colTopic: 'Ilmiy ish mavzusi',
      colUrl: 'URL manzil (havola)',
      goToLink: "Havolaga o'tish",
      noLink: "Havola yo'q",
      filterAll: 'Barchasi',
      filterInternational: 'Xalqaro',
      filterLocal: 'Mahalliy',
      filterScopus: 'Scopus / WoS',
      filterNew: "Yangi qo'shilganlar",
      badgeNew: 'Yangi',
      emptyList: "Ma'lumot topilmadi"
    },

    baholash: {
      blocks: [
        { type: 'lead', text: 'Taʼlim sifatini baholash va monitoring qilish boshqarmasi' },
        { type: 'label', text: 'Boshqarmada quyidagi boʻlimlar mavjud:' },
        { type: 'list', items: [
          'Baholash va ijtimoiy-amaliy tadqiqotlar boʻlimi',
          'Xalqaro dasturlar va reytinglardagi koʻrsatkichlar tahlili boʻlimi'
        ] },
        { type: 'section', text: 'Boshqarmaning vazifa va funksiyalari' },
        { type: 'list', items: [
          'maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tashkilotlarida davlat taʼlim standartlari bajarilishini va taʼlim sifatiga taʼsir qiluvchi omillarni aniqlash hamda tizimli monitoringni amalga oshirish;',
          'maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tashkilotlari hamda oʻquv kurslarini litsenziyalash, attestatsiya va davlat akkreditatsiyasidan oʻtkazish jarayonlarini muvofiqlashtirish;',
          'taʼlim tashkilotlarida oʻquv-tarbiya jarayoni va kadrlar tayyorlash sifatini monitoring qilish, oʻquvchilar bilimi standartlarga muvofiqligini tahlil qilish va baholashning zamonaviy tizimlarini joriy etish;',
          'taʼlim sohasida dalillarga asoslangan qarorlar qabul qilish uchun tizimli maʼlumotlarni toʻplash, ijtimoiy-amaliy tadqiqotlar oʻtkazish va ilmiy asoslangan takliflar tayyorlash;',
          'taʼlim standartlari, oʻquv rejalari, dasturlar va darsliklarning samaradorligini muntazam tahlil qilish hamda ularni takomillashtirish boʻyicha tavsiyalar ishlab chiqish;',
          'oʻquvchilarning taʼlimdagi yutuqlarini baholash boʻyicha xalqaro dasturlar va tadqiqotlarda (PISA, PIRLS, TIMSS, TALIS) ishtirokini taʼminlash hamda reytinglardagi koʻrsatkichlarni yaxshilashda koʻmaklashish;',
          'xalqaro tashkilotlar, universitetlar va ilmiy markazlar bilan hamkorlik aloqalarini yoʻlga qoʻyish, tadqiqot natijalari asosida oʻqituvchilar malakasini oshirish va ilgʻor xalqaro benchmarking amaliyotini joriy etish;',
          'xalqaro va milliy baholash natijalarini ommaviy axborot vositalari hamda ijtimoiy tarmoqlarda keng targʻib qilish, soha faoliyatiga doir ilmiy maqolalar tayyorlash va chop etish;',
          'vakolatli organlar bilan hamkorlikda taʼlim tashkilotlari faoliyatini baholash mezonlarini ishlab chiqishda ishtirok etish.'
        ] }
      ]
    },

    raqamli: {
      blocks: [
        { type: 'lead', text: 'Raqamli savodxonlik va innovatsion texnologiyalarni joriy etish boshqarmasi' },
        { type: 'label', text: 'Boshqarmada quyidagi boʻlimlar mavjud:' },
        { type: 'list', items: [
          'Raqamli pedagogika va mediataʼlimni rivojlantirish boʻlimi',
          'Raqamli texnologiyalar va innovatsiyalarni joriy etish boʻlimi'
        ] },
        { type: 'section', text: 'Boshqarmaning vazifa va funksiyalari' },
        { type: 'list', items: [
          'taʼlim tizimida raqamli savodxonlikni oshirish, taʼlim ishtirokchilarining raqamli kompetensiyalari va koʻnikmalarini rivojlantirishga qaratilgan dastur, loyiha, metodik materiallar va oʻquv-metodik majmualarni ishlab chiqish hamda joriy etish;',
          'raqamli pedagogika, mediataʼlim va zamonaviy oʻqitish texnologiyalarini taʼlim jarayoniga integratsiya qilish, sohadagi ilgʻor xorijiy tajribalarni oʻrganib, mahalliy sharoitga moslashtirish;',
          'taʼlim jarayonida sunʼiy intellekt texnologiyalaridan foydalanish etikasi, maʼlumotlar maxfiyligi va axborot xavfsizligini taʼminlash boʻyicha metodik tavsiyalar, oʻquv-uslubiy qoʻllanmalar hamda yoʻriqnomalar ishlab chiqish;',
          'taʼlim jarayonida virtual va kengaytirilgan reallik (VR/AR), simulyatorlar, interfaol platformalar va boshqa innovatsion raqamli texnologiyalardan foydalanish tizimini shakllantirish hamda ularning samaradorligini baholash boʻyicha tajriba-sinov loyihalarini amalga oshirish;',
          'maktabgacha va maktab taʼlimi muassasalari uchun raqamli oʻquv kontentlarini (video darslar, interfaol mashgʻulotlar, multimedia resurslari, oʻquv platformalari) yaratish, ularning sifatini metodik hamda texnik jihatdan ekspertizadan oʻtkazishga koʻmaklashish;',
          'taʼlim muassasalari faoliyatida innovatsion yechimlar va raqamli boshqaruv mexanizmlarini joriy etish, jarayonlarni avtomatlashtirish boʻyicha ilmiy-uslubiy koʻmak koʻrsatish hamda tahliliy xulosalar tayyorlash;',
          'raqamli taʼlim platformalari, maʼlumotlar bazalari va oʻquv jarayonini boshqarish tizimlarini (LMS, LXP, LRS) joriy etish hamda ularning uzluksiz, samarali ishlashini taʼminlash boʻyicha ilmiy-uslubiy tadqiqotlar oʻtkazish;',
          'taʼlimda EdTech, elektron oʻquv resurslari, virtual laboratoriyalar va simulyatorlarni joriy etish boʻyicha metodik hamda tashkiliy yechimlar ishlab chiqish, qoʻllanilayotgan texnologiyalarni baholash va takomillashtirish;',
          'pedagoglarning raqamli kompetensiyalarini rivojlantirishga oid qisqa muddatli malaka oshirish kurslari, treninglar va vebinarlar uchun kontent, oʻquv-uslubiy majmualar hamda metodik materiallar tayyorlash;',
          'raqamli taʼlim, mediataʼlim va innovatsiyalar sohasida tahliliy, ilmiy-amaliy tadqiqotlar oʻtkazish, tadqiqot natijalari asosida soha rivojiga oid strategik taklif va tavsiyalar ishlab chiqish;',
          'xalqaro tashkilotlar, donorlar va texnologik kompaniyalar bilan hamkorlikda raqamli taʼlim va innovatsion texnologiyalarni joriy etish sohasida qoʻshma dastur hamda xalqaro grant loyihalarini amalga oshirish, tegishli tashabbuslarni muvofiqlashtirish.'
        ] }
      ]
    },

    normativ: {
      blocks: [
        { type: 'lead', text: 'Taʼlimni pedagogik-psixologik qoʻllab-quvvatlash boshqarmasi' },
        { type: 'label', text: 'Boshqarmada quyidagi boʻlimlar mavjud:' },
        { type: 'list', items: [
          'Pedagogik mahorat va inklyuziv taʼlimni rivojlantirish boʻlimi',
          'Psixologik xizmatni rivojlantirish va kasbga yoʻnaltirish boʻlimi'
        ] },
        { type: 'section', text: 'Boshqarmaning vazifa va funksiyalari' },
        { type: 'list', items: [
          'maktabgacha, umumiy oʻrta va maktabdan tashqari taʼlim tizimida pedagogik va psixologik qoʻllab-quvvatlashni ilmiy-metodik jihatdan taʼminlash, pedagog va psixolog kadrlarning kasbiy rivojlanishini qoʻllab-quvvatlash, inklyuziv taʼlim hamda kasbga yoʻnaltirish tizimini takomillashtirish;',
          'ilgʻor milliy va xalqaro tajribalarni oʻrganish, zamonaviy yondashuvlarni joriy etish hamda taʼlim ishtirokchilari uchun xavfsiz, inklyuziv va rivojlantiruvchi taʼlim muhitini shakllantirishga xizmat qiluvchi ilmiy-metodik ishlanmalarni tayyorlash;',
          'taʼlimni pedagogik va psixologik qoʻllab-quvvatlash, kadrlarni kasbiy rivojlantirish tizimini ilgʻor tajriba va tadqiqotlar asosida takomillashtirish;',
          'taʼlim-tarbiya jarayoniga innovatsion paradigma va metodikalarni joriy etish, taʼlim ishtirokchilarida mafkuraviy immunitetni shakllantirish, inklyuziv, psixologik barqaror va rivojlantiruvchi taʼlim muhitini yaratish mexanizmlarini takomillashtirish;',
          'pedagog kadrlar faoliyatiga oid talablarni belgilash, ularni kasbiy rivojlantirish, insonparvarlik, shaxs va ijtimoiy hamkorlikni barqaror rivojlantirish, inklyuzivlik gʻoyalariga asoslangan qadriyat va mafkuraviy amaliyot, samarali taʼlim strategiyalarini joriy etish;',
          'psixologlar faoliyatini muvofiqlashtirish, kasbiy rivojlantirish, zamonaviy amaliyot va texnologiyalar, ilgʻor tajribalarni joriy etish, taʼlimda psixologik farovonlik, ishonch va rivojlanish muhitini yaratishni metodik qoʻllab-quvvatlash;',
          'taʼlim jarayonida jahon ilm-fani va texnologiyalari yutuqlaridan keng foydalanish boʻyicha ilmiy ishlanmalar va tavsiyalar tayyorlash;',
          'uzluksiz taʼlimni strategik qoʻllab-quvvatlash va kasbga yoʻnaltirishni tizimli amalga oshirish, hayot davomida taʼlim olishning barqaror koʻnikmalarini shakllantirish, mehnat bozorining real talablariga mos ravishda kasbga yoʻnaltirish modellari, dasturlari, shaxsiy taʼlim va martaba trayektoriyalarini ishlab chiqish hamda joriy etish.'
        ] }
      ]
    }
  }
}
